import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { Link } from "react-router-dom";

import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import FilterTabs from "../../../common/FilterTabs";

import Loader from "../../../Parts/Loader";
import NotificationBar from "../../../Parts/NotificationBar.jsx";

import ArrowLeft from "../../../Icons/ArrowLeft";
import MappingTable from "./MappingTable";
import ProgressBar from "../common/ProgressBar";
import SalesforceMapping from "./SalesforceMapping";
import SalesforceSettingComplete from "../common/SalesforceSettingComplete";

import {
  SalesforceSettingStep,
  salesforceImportMappingFormProps,
  SalesforceSettingDirectory,
  SalesforceObjectType,
  DialogType,
  salesforceAddressSettingSteps,
} from "../../../../constants/ComponentTypes";
import { makeSalesforceMap } from "../../../../utils/utils";

const { Set, Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  returnBtn: {
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
  },

  heading: {
    width: "100%",
    marginTop: "14px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "30px",
  },

  body: {
    width: "100%",
    margin: "40px 0px 90px 0px",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },

  field: {
    marginBottom: "36px",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "24px",
  },

  settingButton: {
    color: "#1A65FF",
    fontSize: "13px",
    fontWeight: "bold",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "1px",
    marginLeft: "18px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class SalesforceAddressSetting extends React.Component {
  state = {
    step: SalesforceSettingStep.OVERVIEW,
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
    sobject_name: 0,
    listview_id: null,
  };

  componentWillMount() {
    this.props.getUserInfo();
    this.props.getSalesforceImportMappings();

    let mapping = this.state.mapping;
    salesforceImportMappingFormProps.forEach((prop) => {
      mapping = mapping.set(prop.key, Set());
    });
    this.setState({
      mapping: mapping,
      sobject_name: this.props.sobject_name,
      listview_id: this.props.listview_id,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    if (this.props.isLoadingMapping && !nextProps.isLoadingMapping) {
      this.setState({
        mapping: makeSalesforceMap(nextProps.mapping),
      });
    }

    if (this.props.sobject_name !== nextProps.sobject_name) {
      this.setState({
        sobject_name: nextProps.sobject_name,
      });
    }

    if (this.props.listview_id !== nextProps.listview_id) {
      this.setState({
        listview_id: nextProps.listview_id,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // ジョブ実行後でリロードされた場合を考慮し、ユーザー情報が取得でき次第、接続・再接続する
    if (this.props.user && !prevProps.user) {
      this.props.jobCompleted(this.props.user.id);
    }
  }

  /*** toggle funcions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToStep = (step) => {
    this.setState({ step: step });
  };

  handleTabClicked = (value) => {
    let directory = Object.values(SalesforceSettingDirectory).find(
      (item) => item.value === value
    );
    this.props.goTo(directory.setting_path);
  };

  handleUpdateMapping = (mapping) => {
    this.setState({
      mapping: mapping,
    });
  };

  /*** render functions ***/
  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderLoading = () => (
    <div className={this.props.classes.box}>
      <Loader type="color" />
    </div>
  );

  renderError = () => {
    const { classes } = this.props;

    if (this.props.expiredAccessError) {
      return (
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            認証情報が失効しています。
            <a
              href={
                process.env.REACT_APP_API_BASE_URL +
                "/oauth2/salesforce?redirect_url=" +
                process.env.REACT_APP_FRONTEND_URL +
                "/setting/integrations/salesforce"
              }
              target="_self"
              className={classes.link}
            >
              こちら
            </a>
            より再設定してください。
          </Typography>
        </div>
      );
    } else {
      return (
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            自社リスト連携が設定されていません。
            <Link
              to={SalesforceSettingDirectory.ADDRESS_BOOK.setup_path}
              className={classes.link}
            >
              こちら
            </Link>
            で設定してください。
          </Typography>
        </div>
      );
    }
  };

  renderOverview = () => {
    const { classes, sobject_name, isLoadingMapping } = this.props;

    let listviewItem = this.props.listviews
      ? this.props.listviews.find((item) => item.id === this.props.listview_id)
      : null;
    let listview_label = listviewItem ? listviewItem.label : "-";

    return (
      <div className={classes.overview}>
        <div
          className={classes.progressbar}
          style={{ justifyContent: "flex-start" }}
        >
          <Button
            className={classes.returnBtn}
            onClick={() => this.props.goTo(`/setting/integrations/salesforce`)}
          >
            <ArrowLeft
              color="#71737B"
              width={14}
              height={14}
              style={{ marginRight: "6px" }}
            />
            <span>戻る</span>
          </Button>
        </div>
        <div className={classes.heading}>
          <Typography variant="title" className={classes.title}>
            Salesforce連携設定
          </Typography>

          <FilterTabs
            value={this.props.tab}
            handleTabClicked={this.handleTabClicked}
            tabValues={Object.values(SalesforceSettingDirectory)}
          />
        </div>
        <div className={classes.body}>
          {(() => {
            if (isLoadingMapping) {
              return this.renderLoading();
            } else if (
              !isLoadingMapping &&
              Object.keys(this.props.mapping).length === 0
            ) {
              return this.renderError();
            } else {
              return (
                <div className={classes.box}>
                  <Typography
                    variant="display1"
                    className={classes.sectionTitle}
                    style={{ marginBottom: "48px" }}
                  >
                    自社リスト連携設定
                  </Typography>

                  <div className={classes.field}>
                    <div className={classes.row}>
                      <Typography
                        variant="title"
                        className={classes.sectionTitle}
                        style={{ marginBottom: "0px" }}
                      >
                        Salesforceオブジェクト
                      </Typography>
                    </div>
                    <Typography
                      variant="subheading"
                      className={classes.fieldDesc}
                    >
                      {!!sobject_name &&
                        SalesforceObjectType.hasOwnProperty(
                          sobject_name.toUpperCase()
                        )
                        ? SalesforceObjectType[sobject_name.toUpperCase()].text
                        : "-"}
                    </Typography>
                  </div>

                  <div className={classes.field}>
                    <div className={classes.row}>
                      <Typography
                        variant="title"
                        className={classes.sectionTitle}
                        style={{ marginBottom: "0px" }}
                      >
                        リストビュー
                      </Typography>
                    </div>
                    <Typography
                      variant="subheading"
                      className={classes.fieldDesc}
                    >
                      {this.props.listview_id === null
                        ? "未選択（全てのレコードを同期する）"
                        : listview_label}
                    </Typography>
                  </div>

                  <div className={classes.field}>
                    <div className={classes.row}>
                      <Typography
                        variant="title"
                        className={classes.sectionTitle}
                        style={{ marginBottom: "0px" }}
                      >
                        項目マッピング
                      </Typography>
                      <Button
                        color="primary"
                        className={classes.settingButton}
                        onClick={() =>
                          this.goToStep(SalesforceSettingStep.MAPPING)
                        }
                      >
                        設定する
                      </Button>
                    </div>
                    <Typography
                      variant="body2"
                      style={{ marginBottom: "43px" }}
                    >
                      Salesforce・Keyman
                      Letter間で同期を自動化するための項目マッピングを設定します。マッピングした項目はSalesforce・Keyman
                      Letter間で手動で同期されます。同期を開始するには、「アカウント
                      ＞ 連携 ＞ Salesforce」と「自社リスト ＞
                      サイドバー」にある同期ボタンをクリックしてください。
                    </Typography>
                    <MappingTable
                      sobject={this.state.sobject_name}
                      step={this.state.step}
                      mapping={this.state.mapping}
                      enableEdit={false}
                      isLoadingMapping={this.props.isLoadingMapping}
                      isLoadingPreview={this.props.isLoadingPreview}
                      fields={this.props.fields}
                      preview={this.props.preview}
                      updateMapping={this.handleUpdateMapping}
                    />
                  </div>
                </div>
              );
            }
          })()}
        </div>
      </div>
    );
  };

  renderEditMapping = () => (
    <SalesforceMapping
      sobject={this.state.sobject_name}
      listview_id={this.props.listview_id}
      listviews={this.props.listviews}
      enableExport={true}
      user={this.props.user}
      type={DialogType.EDIT}
      step={this.state.step}
      mapping={this.state.mapping}
      fields={this.props.fields}
      preview={this.props.preview}
      isLoadingPreview={this.props.isLoadingPreview}
      isJobCompletedLoading={this.props.isJobCompletedLoading}
      isConfiguring={this.props.isConfiguring}
      goBack={() => this.goToStep(SalesforceSettingStep.OVERVIEW)}
      goToStep={this.goToStep}
      updateMapping={this.handleUpdateMapping}
      loadingPreviewFailed={this.props.loadingPreviewFailed}
      postSalesforceConfig={(data) =>
        this.props.postSalesforceConfig({
          ...data,
          sobject_name: this.state.sobject_name,
        })
      }
      getSalesforcePreview={(data) =>
        this.props.getSalesforcePreview(this.props.sobject_name, data)
      }
    />
  );

  render() {
    const { classes } = this.props;

    let notification;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle="自社リスト連携設定"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/setting/integrations/salesforce")
          }
        />
        <div className={classes.content}>
          {(() => {
            if (this.state.step === SalesforceSettingStep.OVERVIEW) {
              return this.renderOverview();
            } else if (
              this.state.step === SalesforceSettingStep.SETTING_COMPLETE
            ) {
              return (
                <SalesforceSettingComplete
                  goTo={this.props.goTo}
                  type={SalesforceSettingDirectory.ADDRESS_BOOK.value}
                  dialogType={DialogType.EDIT}
                  postSalesforceSync={() => {
                    this.props.initializeMessage();
                    this.props.postSalesforceSync();
                  }}
                  isJobCompletedLoading={this.props.isJobCompletedLoading}
                />
              );
            } else {
              return (
                <div>
                  <div className={classes.progressbar}>
                    <ProgressBar
                      step={this.state.step}
                      steps={salesforceAddressSettingSteps}
                    />
                  </div>
                  {(() => {
                    if (
                      this.state.step === SalesforceSettingStep.MAPPING ||
                      this.state.step === SalesforceSettingStep.PREVIEW
                    ) {
                      return this.renderEditMapping();
                    }
                  })()}
                </div>
              );
            }
          })()}
        </div>
        {notification}
      </Wrapper>
    );
  }
}

SalesforceAddressSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  message: PropTypes.string,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  getUserInfo: PropTypes.func,
  getSalesforceImportMappings: PropTypes.func,
  goTo: PropTypes.func,
  tab: PropTypes.number,
  mapping: PropTypes.object,
  isLoadingMapping: PropTypes.bool,
  fields: PropTypes.object,
  preview: PropTypes.array,
  isLoadingPreview: PropTypes.bool,
  loadingPreviewFailed: PropTypes.bool,
  sobject_name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  listview_id: PropTypes.string,
  listviews: PropTypes.array,
  isJobCompletedLoading: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  postSalesforceConfig: PropTypes.func,
  getSalesforcePreview: PropTypes.func,
  postSalesforceSync: PropTypes.func,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  expiredAccessError: PropTypes.bool,
  initializeMessage: PropTypes.func.isRequired,
  jobCompleted: PropTypes.func.isRequired,
};

export default withStyles(styles)(SalesforceAddressSetting);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceAddressSetting.jsx